import React, { useEffect, useState } from 'react'
import HeaderBack from './_HeaderBack'
import aumento from '../../assets/img/aumento.svg'
import listino from '../../assets/files/kit_contrattuale_web.pdf'
import { useSelector } from 'react-redux'
import axios from 'axios'
import CircularProgress from '@mui/material/CircularProgress';
import md5 from 'md5'

function Aumento() {
    const [checkBox, setCheck] = useState(false)
    const podCode = useSelector((user) => user.user.info.pod_code)
    const potenza = useSelector((user) => user.user.info.potenza)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const [selectValue, setSelectVal] = useState(potenza)
    const opzione = useSelector((user) => user.user.info.opzione_tariffaria)
    const [result, setResult] = useState(null)
    const [loading, setLoading] = useState(true)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 


    useEffect(() => {
        change()

       
    },[selectValue])

    const change = async (e) => {
        setLoading(true)
        const res = await axios.get(`https://my.revoluce.it/area_utente/gestione/api/faidate/preventivoCambioPotenza.php?potenza_attuale=${potenza}&potenza_richiesta=${selectValue}&opzione_tariffaria=${opzione}&customer_id=${customerId}&tkn_pvt=${tkn}`)
        setResult(res.data.preventivo)
        setTimeout(() => {
            setLoading(false)
        },2000)
    }
    const check = async () => {
        if(!checkBox){
            alert('Devi accettare termini e condizioni')
        } else {
            const url = `https://my.revoluce.it/area_utente/gestione/api/faidate/aumentoPotenza.php?customer_id=${customerId}&codice_pod=${podCode}&potenza_attuale=${potenza}&potenza_richiesta=${selectValue}`
            await axios.get(url)
        }
    }
    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={0}/>
            <div className="icon">
                <img src={aumento} alt="aumento" />
            </div>
            <div className="body">
                <div className="paragraph">
                    <h1 className="h1">Aumento Potenza</h1>
                    <p>Con l' aumento di potenza puoi aumentare la potenza del tuo contatore.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Come richiedere un aumento di potenza?</h2>
                    <p>La potenza del contatore si misura in kilowatt (kW) e rappresenta il limite massimo che possiamo assorbire dalla rete elettrica. La potenza può essere aumentata o diminuita a seconda delle proprie esigenze.
                        Il contatore è di proprietà del distributore della tua zona. Per qualsiasi intervento tecnico o telematico sul contatore è perciò il distributore ad intervenire ed è compito di Revoluce comunicare a al distributore la tua richiesta.
                    </p>
                    <p>Per saperne di più vai sul nostro blog <a href="https://revoluce.zendesk.com/hc/it/articles/360017493317-Come-variare-la-potenza-del-contatore">cliccando qui.</a></p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Tempi e Costi</h2>
                    <p><span className="bold">Tempo massimo di lavorazione:</span> 7 giorni lavorativi dalla richiesta del cliente.</p>
                    <p><span className="bold">Costo:</span> da calcolare in base alla potenza attuale e quella di destinazione (vedi configuratore sotto). Il costo del cambio di potenza verrà addebitato all’interno del primo Estratto Conto utile.</p>
                </div>
                <div className="paragraph box">
                    <p>Modificando la potenza del contatore il tuo prezzo al kWh e l’eventuale canone fisso mensile si andranno ad aggiornare secondo i prezzi attualmente in vigore, in base al “Listino prezzi Revoluce in vigore oggi” che puoi <a href={listino}>trovare qui</a></p>
                </div>
                <div className="paragraph boxForm">
                    <h2 className="h2">Voglio aumentare la potenza del mio contatore</h2>
                    <div className="select">
                        <h2>La potenza attuale del tuo contatore:</h2>
                        <select>
                            <option value={potenza}>{parseFloat(potenza)} kW</option>
                        </select>
                        <h2>Seleziona la potenza a cui vuoi portare il contatore:</h2>
                        <select onChange={(e) => setSelectVal(e.target.value)} value={selectValue}>
                            <option value="0.5">0,5 kW</option>
                            <option value="1.00">1 kW</option>
                            <option value="1.5">1,5 kW</option>
                            <option value="2.00">2 kW</option>
                            <option value="2.5">2,5 kW</option>
                            <option value="3.00">3 kW</option>
                            <option value="3.5">3,5 kW</option>
                            <option value="4.00">4 kW</option>
                            <option value="4.5">4,5 kW</option>
                            <option value="5.00">5 kW</option>
                            <option value="5.5">5,5 kW</option>
                            <option value="6.00">6 kW</option>
                            <option value="7.00">7 kW</option>
                            <option value="8.00">8 kW</option>
                            <option value="9.00">9 kW</option>
                            <option value="10.00">10 kW</option>
                            <option value="15.00">15 kW</option>
                        </select>
                    </div>
                    {result !== null ? (
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', marginTop: '15px'}}>
                            <h2 className="h2">Totale:</h2>
                            <h2 className="h2">{loading ? <CircularProgress size={20} /> : result}</h2>
                        </div>
                    ) : null}
                    <div className="checkbox">
                        <input type="checkbox" onChange={() => setCheck(!checkBox)}/>
                        <p>Proseguendo con l’invio della richiesta dichiaro di aver letto ed accettato le tempistiche necessarie per il completamento dell’operazione e il preventivo di costo indicato.</p>
                    </div>
                    <div className="cta">   
                        <button onClick={() => check()}>Inoltra richiesta</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aumento
